export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";

export const userLogin = userLoggedIn => ({
  type: USER_LOGIN,
  userLoggedIn
});

export const userLogout = userLoggedIn => ({
  type: USER_LOGOUT,
  userLoggedIn
});



// WEBPACK FOOTER //
// ./src/actions/index.js